import CampaignProductDropdownSearch from "./campaignProductDropdownSearch.container"

export default CampaignProductDropdownSearch